import { useEffect, useState } from 'react';
import { Tabs, Form, Spin } from 'antd';
import PropTypes from 'prop-types';
import { renderTabBarProducts } from '../MarkupAndBaseRateStyledWrapper/MarkupAndBaseRateStyledWrapper';
import PartnerBaseRateModeWise from './PartnerBaseRateModeWise';
import { BASE_RATE_PRODUCTS_CONSTANT } from './const';

function PartnerBaseRateWrapper({ partnerID, hasData, productWiseMode, updatedAt }) {
  const [baseRateForm] = Form.useForm();
  const baseRateFormValues = Form.useWatch([], baseRateForm);

  const [formButtonDisabled, setFormButtonDisabled] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);

  const updatePartnerBaseRate = () => {
    setIsProcessing(true);
    Object.entries(productWiseMode).forEach(([productKey, productValue]) => {
      Object.entries(productValue).forEach(([mode, data]) => {
        baseRateForm?.setFieldValue([productKey, mode, 'is_enable'], data?.is_enable); // Setting field values dynamically)
        if (!data?.slab || data?.slab?.length < 1) {
          baseRateForm?.setFieldValue(
            [productKey, mode, 'slab'],
            [
              {
                min_amount: 0,
                max_amount: null,
                base_rate_type: 'PERCENTAGE',
                base_rate_value: 0
              }
            ]
          );
        } else {
          baseRateForm?.setFieldValue([productKey, mode, 'slab'], data?.slab);
        }
      });
    });
    setIsProcessing(false);
  };

  const handleSwitchChange = (e, productKey, mode) => {
    baseRateForm.setFieldValue([productKey, mode, 'is_enable'], e);
  };

  const handleEdit = () => {
    setFormButtonDisabled(!formButtonDisabled);
  };

  const getBaseRateProductsValue = (key) => BASE_RATE_PRODUCTS_CONSTANT[key]?.value || key;

  useEffect(() => {
    if (partnerID && hasData) {
      updatePartnerBaseRate();
    }
  }, [partnerID, hasData]);

  return (
    <Spin spinning={isProcessing} tip="Processing..." size="large">
      <Tabs
        key="products"
        defaultActiveKey="1"
        tabPosition="top"
        type="card"
        renderTabBar={renderTabBarProducts}
        style={{
          marginTop: '12px'
        }}
        tabBarGutter={8}
        items={Object.entries(productWiseMode).map(([productKey, productValue]) => {
          return {
            label: `${getBaseRateProductsValue(productKey)}`,
            key: productKey,
            children: (
              <PartnerBaseRateModeWise
                baseRateForm={baseRateForm}
                productKey={productKey}
                productValue={productValue}
                baseRateFormValues={baseRateFormValues}
                handleSwitchChange={handleSwitchChange}
                handleEdit={handleEdit}
                formButtonDisabled={formButtonDisabled}
                updatedAt={updatedAt}
              />
            )
          };
        })}
      />
    </Spin>
  );
}

PartnerBaseRateWrapper.propTypes = {
  partnerID: PropTypes.number.isRequired,
  hasData: PropTypes.bool.isRequired,
  productWiseMode: PropTypes.instanceOf(Object).isRequired,
  updatedAt: PropTypes.string.isRequired
};

export default PartnerBaseRateWrapper;
